import { IUserCompanyRoles } from "@redbelly-tokeniser/mystake-common-sdk";
import { useCompanyContext } from "../companies/useCompanyContext";

/**
 * Pure predicate: is this user an APPROVER-only user for the company in scope?
 *
 * An APPROVER-only user (`isApprover && !isAdmin`) has view-only access to the
 * Admin area. Write controls must be suppressed for them across every surface
 * so they never trigger a backend 403.
 *
 * Dual-role Admin+Approver users and SUPER_ADMIN keep full edit rights —
 * `isAdmin` already includes SUPER_ADMIN, so this check excludes both.
 */
export const isApproverReadOnly = (userCompanyRoles: IUserCompanyRoles): boolean =>
  Boolean(userCompanyRoles.isApprover) && !userCompanyRoles.isAdmin;

/**
 * Hook returning `true` when the current user is an APPROVER-only user for the
 * company in scope. Every 9.6 view-only surface MUST consume this single helper
 * (no ad-hoc role checks) so the treatment stays consistent.
 */
export const useApproverReadOnly = (): boolean => {
  const { userCompanyRoles } = useCompanyContext();
  return isApproverReadOnly(userCompanyRoles);
};
